/*eslint-disable*/

import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import Key from '../../../clientVariables.json';
import { toast } from 'react-toastify';
import SendMailContract from './SendMailContract';
import { setSelectedContractInvoiceDataAction } from '../redux/action';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreateAgreementButton = ({
  rows,
  formData,
  changeContract,
  customerData,
  action,
  contractAddedSuccessHandler,
}) => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const dispatch = useDispatch();
  const selectedContract = useSelector((state) => state.contractsManagement.selectedContract);
  const [open, setOpen] = useState(false);
  const [sendMailOpen, setSendMailOpen] = useState({
    isOpen: false,
    contractData: null,
    invoiceData: null,
  });

  // useEffect(() => {
  //     console.log('createContractDialogHandler', isOpen);
  //     if(isOpen){
  //         handleClickOpen();
  //     }
  // }, [isOpen]);

  useEffect(() => {
    // console.log("change con", changeContract);
  }, []);

  const handleClickOpen = () => {
    if (!customerData) {
      toast.error('Customer Details Not Found');
    } else if (!formData?.id) {
      toast.error('fill details');
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    // contractAddedSuccessHandler();
  };

  const generateInvoiceId = () => {
    // const paddedUserId = customerDetails ? customerDetails?.id.toString().padStart(6, '0') : '0';
    const newContractId = `IN${currentUser?.id}${moment().format('YYYYMMDDhhmmss')}`;
    // console.log('moment().format("YYYYMMDDHHMM")', moment().format("YYYYMMDDhhmmss"));
    return newContractId;
  };

  const contractHandler = async () => {
    const itemsData = [];
    rows.map((data) => {
      const line = {
        id: data.itemID,
        contract_number: formData.id,
        name: data.name,
        description: data.description,
        type: '',
        uom: data.uom,
        quantity: data.quantity,
        price: data.price,
        discount: data.discount,
        lineTotal: data.lineTotal,
        status: data.status,
      };
      itemsData.push(line);
    });
    // console.log("items data", itemsData);
    try {
      const response = await axios.post(`${Key.domain}/payment/contract`, {
        admin_id: currentUser.id,
        customer_id: selectedContract?.customer_id || formData.customerDetails?.id,
        number: formData.id,
        start_date: moment(formData.startDate).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(formData.endDate).format('YYYY-MM-DD HH:mm:ss'),
        sub_total: formData.subTotal.toString(),
        tax: '0',
        duration: formData.duration,
        period: formData.period,
        description: formData.description,
        items: itemsData,
        create_contract: true,
        price_list_id: formData.priceList.id,
        total: formData.grandTotal.toString(),
        discount: formData.totalDiscount.toString(),
        company_id: selectedContract?.company_id || formData.customerDetails?.companyid,
        parent_contract: selectedContract?.id || 0,
        trail_days: formData.trailDays,
        contract_action: action === 'update' ? 1 : 0,
        package: formData.package === 'Standard' ? 1 : 0, 
      });
      // console.log(response);
      if (response.status === 200) {
        const res = response.data.data;
        console.log('res contract', res);
        if (res?.msg === 'Contract is already exists on your company') {
          toast.error(res.msg);
        } else {
          try {
            const response = await axios.post(`${Key.domain}/payment/invoice`, {
              number: generateInvoiceId(),
              admin_id: currentUser?.id,
              company_id: res?.company_id,
              customer_id: res?.customer_id,
              contract_number: res?.number,
              invoice_date: moment().format('YYYY-MM-DD HH:mm:ss'),
              sub_total: res?.sub_total,
              discount: res?.discount,
              tax: res?.tax,
              total: res?.total,
              payment_terms: 'DOR',
              due_date: moment().format('YYYY-MM-DD HH:mm:ss'),
              address1: res.address1,
              address2: res.address2,
              trail_days: res?.trail_days,
            });
            // console.log("invoice response", response);
            if (response.status === 200) {
              // setSelectedCustomerDetails(response.data.data);
              dispatch(setSelectedContractInvoiceDataAction(response.data.data));
              setSendMailOpen((prev) => ({
                ...prev,
                isOpen: true,
                invoiceData: response.data.data,
                contractData: res,
              }));
              toast.success('Contract Added Successfully');
            } else {
              toast.error('Something went wrong try again..!');
            }
          } catch (error) {
            console.error(error);
            toast.error('Something went wrong try again..!');
          }
        }
      }
      handleClose();
    } catch (error) {
      console.error(error);
      handleClose();
      toast.error('Something went wrong try again..!');
    }
  };

  // const createAndSendContract = async() => {
  //   const itemsData = [];
  //   rows.map((data) => {
  //     const line = {
  //       id: data.itemID,
  //       contract_number: formData.id,
  //       name: data.name,
  //       description: data.description,
  //       type: '',
  //       uom: data.uom,
  //       quantity: data.quantity,
  //       price: data.price,
  //       discount: data.discount,
  //       lineTotal: data.lineTotal,
  //       status: data.status,
  //     }
  //     itemsData.push(line);
  //   });
  //   // console.log("items data", itemsData);
  //   try {
  //     const response = await axios.post(`${Key.domain}/payment/contract`, {
  //       admin_id: currentUser.id,
  //       customer_id: formData.customerDetails?.id,
  //       number: formData.id,
  //       start_date: moment(formData.startDate).format('YYYY-MM-DD HH:mm:ss'),
  //       end_date: moment(formData.endDate).format('YYYY-MM-DD HH:mm:ss'),
  //       sub_total: formData.subTotal.toString(),
  //       tax: '0',
  //       duration: formData.duration,
  //       period: formData.period,
  //       description: formData.description,
  //       items: itemsData,
  //       create_contract: true,
  //       price_list_id: formData.priceList.id,
  //       total: formData.grandTotal.toString(),
  //       discount: formData.totalDiscount.toString(),
  //       company_id: formData.customerDetails?.companyid,
  //       parent_contract: selectedCustomerDetails?.id || 0,
  //       trail_days: formData.trailDays,
  //       contract_action: action === 'update' ? 1 : 0
  //     });
  //     console.log(response);
  //     if(response.status === 200){
  //       const res = response.data.data;
  //       try {
  //         const response =await axios.post(`${Key.domain}/payment/invoice`, {
  //           number: generateInvoiceId(),
  //           admin_id: currentUser?.id,
  //           company_id: res?.company_id,
  //           customer_id: res?.customer_id,
  //           contract_number: res?.number,
  //           invoice_date: moment().format('YYYY-MM-DD HH:mm:ss'),
  //           sub_total: res?.sub_total.toString(),
  //           discount: res?.discount.toString(),
  //           tax: res?.tax.toString(),
  //           total: res?.total.toString(),
  //           payment_terms: "DOR",
  //           due_date: moment().format('YYYY-MM-DD HH:mm:ss'),
  //           address1: res.address1,
  //           address2: res.address2,
  //           trail_days: res?.trail_days,

  //         });
  //         console.log("invoice response", response);
  //         if(response.status === 200){
  //           const res = response.data.data;
  //           setSelectedCustomerDetails(response.data.data);
  //           toast.success("Contract Added Successfully");
  //           try {
  //             const response =await axios.post(`${Key.domain}/payment/mail/send_contract`,{
  //               invoice_number: res.invoice_no,
  //             });
  //           } catch (error) {
  //             console.error(error);
  //             toast.error("Something went wrong try again..!");
  //           }
  //         }
  //       } catch (error) {
  //         console.error(error);
  //         toast.error("Something went wrong try again..!");
  //       }
  //     }
  //     handleClose()
  //   } catch (error) {
  //     console.error(error);
  //     handleClose();
  //     toast.error("Something went wrong try again..!");
  //   }
  // }

  const darkBG = {
    // borderTop: '1px solid #eee',
    // borderBottom: '1px solid #eee',
    bgcolor: '#eee',
  };
  const boxStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 4,
    mb: '5px',
    p: '5px',
  };

  return (
    <>
      <Button
        variant="outlined"
        disableElevation
        onClick={handleClickOpen}
        disabled={changeContract === 'change-agreement' && action !== 'update'}
      >
        {`${changeContract === 'change-agreement' ? 'Change Agreement' : 'Create Agreement'}`}
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{`Create ${
          changeContract === 'change-agreement'
            ? 'Changed Subscription Service Agreement'
            : 'Subscription Service Agreement'
        } for ${customerData?.company_name} - (${customerData?.full_name})?`}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-slide-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText> */}
          {/* <Typography variant="body2" >Service end Date</Typography>
                <Typography variant="body2" >Trail End Date</Typography>
                <Typography variant="body2" >Billing Date</Typography> */}
          <Box sx={{ ...boxStyles }}>
            <Box>
              <Typography variant="body2">Service Start Date</Typography>
            </Box>
            <Box>
              <Typography variant="body2">{moment(formData.startDate).utc().format('LL')}</Typography>
            </Box>
          </Box>
          <Box sx={{ ...boxStyles, ...darkBG }}>
            <Box>
              <Typography variant="body2">Service End Date</Typography>
            </Box>
            <Box>
              <Typography variant="body2">{moment(formData.endDate).utc().format('LL')}</Typography>
            </Box>
          </Box>
          {/* <Box sx={{...boxStyles}}>
            <Box>
                <Typography variant="body2" >Trail End Date</Typography>
                
            </Box>
            <Box>
                <Typography variant="body2" >{moment(formData.startDate).format("LL")}</Typography>
            </Box>
          </Box> */}
          <Box sx={{ ...boxStyles }}>
            <Box>
              <Typography variant="body2">Billing Date</Typography>
            </Box>
            <Box>
              <Typography variant="body2">{moment(formData.startDate).format('LL')}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={contractHandler}>Create Contract</Button>
          {/* <Button onClick={createAndSendContract}>Send Mail</Button> */}
        </DialogActions>
      </Dialog>
      <SendMailContract isOpen={sendMailOpen} />
    </>
  );
};

export default CreateAgreementButton;
